import { GovernanceWorkspace } from '@/components/governance/governance-workspace'

export function AdminPolls() {
  return <GovernanceWorkspace basePath="/admin/polls" />
}
